module.exports = __webpack_public_path__ + "img/goal.c87c9e74.svg";